import {Component, Vue} from 'vue-property-decorator';
import queryConstructor from '@/components/query/query-constructor';
import _ from 'lodash';

@Component
export default class ReportFiltersCommon extends Vue {
  getReportFilters() {
    //@ts-ignore
    const report = this.reportQuery();

    let filterTables: any[] = [];
    let filterValues: any[] = [];
    let filterOptions: any[] = [];

    const push = (n: any, cb: Function = new Function()) => {
      if (n.filterTables)
        filterTables.push(n.filterTables);
      if (n.filterValues)
        filterValues.push(n.filterValues);
      if (n.filterOptions)
        filterOptions.push(n.filterOptions);
      if (cb) cb();
    };

    push(report, () => push(this));

    (report.drill || []).forEach((i: object) => {
      push(i);
    });
    if (filterTables.length && filterValues.length && filterOptions.length)
      return {
        filterTables,
        filterValues,
        filterOptions: report.filterOptions
      };

    return {}
  }

  get groupBy() {
    //@ts-ignore
    return this.type || this.$route.params.type;
  }

  getInitialFilters() {
    const query = JSON.parse(JSON.stringify(this.$store.getters.reportParams));
    // const query = this.$store.getters.reportParams // fix custom column, should mutate for tree levels first column
    if(!query.compareEnabled){
      delete query.compareEnabled;      
      delete query.compareFrom;      
      delete query.compareTo;      
      delete query.compareDate;      
    } 
    //@ts-ignore
    if (query.columns && this.grouping) {
      //@ts-ignore
      query.columns[0] = this.grouping;
    }

    query.groupBy = this.groupBy;

    let url_data = queryConstructor.decode(this.$route.params.data) || {};
    const orphanParams = ['orderBy', 'orderDir'];

    //TODO: columns issue
    orphanParams.forEach((param) => {
      if(!this.$store.getters.reportParams[param] && url_data[param]) {
        query[param] = url_data[param];
      }
    });

    return query;
  }


  getFilters() {
    return {
      ...this.getInitialFilters(),
      ...this.getReportFilters(),
    }

  }

  //#GDB: requestLink
  get requestLink() {
    const { name } = this.$route;

    switch(name) {
      case 'app.conversions':
        return '/report/conversions';

      case 'app.postbacks':
        return '/report/postbacks';

      case 'app.errors':
        return '/report/errors';

      case 'app.live-visits':
        return `/report/live-visits`;

      case 'app.live-clicks':
        return `/report/live-clicks`;

      default:
        return '/report';
    }
  }
  
  //Return valid query
  verifyQuery(query: any, treeLevel: number) {

    const { commit } = this.$store;

    //@ts-ignore
    this.selectedMetrics.forEach((column: string) => {
      if (query.columns.indexOf(column) === -1) {
        query.columns.push(column);
      }
    });

    const columns = query.columns || [];

    if(treeLevel === 0) {
      if(query.filterHaving && query.filterHaving.length) {
        for(let i in query.filterHaving) {
          if(columns.indexOf(query.filterHaving[i]) === -1) {
            this.$store.commit('tableRemoveColumnsFilter', query.filterHaving[i]);

            delete query.filterHaving[i];
            delete query.filterHavingOptions[i];
            delete query.filterHavingValues[i];
          }
        }
      }

      if(query.filterHaving && !query.filterHaving.length) {
        delete query.filterHaving;
        delete query.filterHavingOptions;
        delete query.filterHavingValues;
      }
    } else {
      delete query.filterHaving;
      delete query.filterHavingOptions;
      delete query.filterHavingValues;
    }

    //TODO: columns issue
    if (query.orderBy && columns.indexOf(query.orderBy) === -1) {
      query.orderBy = columns[columns.length - 1];
    }

    query.offset = query.offset || 0;
    return query;
  }
}
